import type { CART_TYPE } from '~/hooks/useCartTypeParam';

export const ROOT_ROUTER = {
  root: '/',
} as const;

export const ADDRESS_ROUTER = {
  root: '/addresses',
  new: (cartType?: CART_TYPE) =>
    `/addresses/new${cartType ? `?cartType=${cartType}` : ''}`,
  detail: (id: number) => `/addresses/${id}`,
} as const;

export const CLAIMS_ROUTER = {
  root: '/claims',
  detail: (id: number) => `/claims/${id}`,
} as const;

export const ORDERS_ROUTER = {
  root: '/orders',
  detail: (id: number) => `/orders/${id}`,
} as const;

export const VENDORS_ROUTER = {
  vendorDetail: (id: number) => `/vendors/${id}`,
  productDetail: (vendorId: number, offerId: number) =>
    `/vendors/${vendorId}/products/${offerId}`,
} as const;

export const MYPAGE_ROUTER = {
  root: '/mypage',
  refundAccount: '/mypage/refund-account',
  inquiry: '/mypage/inquiries',
  coupons: '/mypage/coupons',
} as const;

export const OFFERS_ROUTER = {
  recentlyViewed: '/offers/recently-viewed',
  popularShowcase: '/offers/popular-showcase',
  frequentlyOrdered: '/offers/frequently-ordered',
  showcase: (code: string) => `/offers/showcase?code=${code}`,
  showcaseGroup: (code: string) => `/offers/showcase-group?code=${code}`,
  emptyShowcase: '/offers/showcase/empty',
} as const;

// 고정 URL인 이벤트 페이지만 등록
export const EVENT_ROUTER = {
  pmwk: '/event/plusweek',
} as const;

export const SEARCH_ROUTER = {
  root: '/search',
  /**
   * @description openPageModal을 통해서 이동할 때만 사용
   * */
  searchText: (text: string) =>
    `/search?searchText=${encodeURIComponent(text)}`,
  productType: (productType: string) => `/search?productType=${productType}`,
} as const;

export const CASHNOTE_MEMBERSHIP_ROUTER = {
  membershipWeekEvent: '/cashnote-membership/promotion/weekly-event',
} as const;

export const CATEGORY_ROUTER = {
  root: '/category',
  categoryTwoDepth: (categoryId: number) => `/category/${categoryId}`,
  vendorCategory: (vendorId: string) => `/vendors/${vendorId}/category`,
  vendorCategoryTwoDepth: (vendorId: string, categoryId: number) =>
    `/vendors/${vendorId}/category/${categoryId}`,
} as const;

export const CAMPAIGN_ROUTER = {
  root: '/campaigns',
  campaignDetail: (campaginCode: string) => `/campaigns/${campaginCode}`,
} as const;

export const CHECKOUT_ROUTER = {
  root: '/checkout',
  quick: '/checkout?cartType=QUICK',
  newUserRecommend: (cartType: CART_TYPE) =>
    `/recommend/new?cartType=${cartType || ''}`,
  recommend: (cartType: CART_TYPE) => `/recommend?cartType=${cartType || ''}`,
  eCouponRoot: '/e-coupon/checkout?productType=E_COUPON',
  eCouponGift: (isGift?: boolean) =>
    `/e-coupon/checkout?productType=E_COUPON&${isGift ? 'gift=true' : ''}`,
} as const;

/**
 * @description 이동을 위한 브릿지 페이지 라우터
 * */
export const BRIDGE_ROUTER = {
  storeRecommend: '/bridge/store-recommend',
  weeklyEvent: '/bridge/weekly-event', // 플멤위크 이벤트 페이지
} as const;

export const EXTERNAL_ROUTER = {
  eCoupon: (encryptedOrderCode: string) =>
    `/external/e-coupon/${encryptedOrderCode}`,
  // FIXME: 경로를 각 상태에 따라서 분리 처리
  checkoutSuccessRedirect: `/public/app/kpn/modal-close`,
  checkoutFailRedirect: `/public/app/kpn/modal-close`,
  checkoutCloseRedirect: `/public/app/kpn/modal-close`,
  checkoutCancelRedirect: `/public/app/kpn/modal-close`,
} as const;
